import React, { useState } from 'react'
import { isValidEmail } from '@toasttab/email-validation'
import { useLoyaltyContext } from '../../context/LoyaltyContext'
import { EmailInput } from '../../FormComponents/EmailInput'
import { PhoneInput } from '../../FormComponents/PhoneInput'
import { ReCaptcha } from '../../FormComponents/ReCaptcha'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '@toasttab/buffet-pui-buttons'
import { isValidPhoneNumber } from 'libphonenumber-js'
import {
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel
} from '@toasttab/buffet-pui-tabs'
import { t } from '@local/translations'
import './style.css'

export const LookupForm = () => {
  const { lookUp, isLookupLoading, resetSignup, config } = useLoyaltyContext()

  const navigate = useNavigate()
  const { shortUrl } = useParams<{ shortUrl?: string }>()

  const [captchaVerified, setCaptchaVerified] = useState(false)
  const [captchaToken, setCaptchaToken] = useState()
  const [emailInput, setEmailInput] = useState('')
  const [phoneInput, setPhoneInput] = useState('')
  const [activeTabIndex, setActiveTabIndex] = useState(0)

  const handleSubmit = () => {
    if (activeTabIndex === 0) {
      // Email tab
      lookUp({ email: emailInput, phone: '', token: captchaToken })
    } else {
      // Phone tab
      lookUp({ email: '', phone: phoneInput, token: captchaToken })
    }
  }

  const isValid = () => {
    if (activeTabIndex === 0) {
      // Email tab validation
      return emailInput !== '' && isValidEmail(emailInput)
    } else {
      // Phone tab validation
      return (
        phoneInput !== '' &&
        isValidPhoneNumber(phoneInput, config?.restaurantCountryCode || 'US')
      )
    }
  }

  const handleTabChange = (index: number) => {
    setActiveTabIndex(index)
    // Clear inputs when switching tabs to avoid confusion
    setEmailInput('')
    setPhoneInput('')

    // Reset reCAPTCHA if available (enterprise version)
    if (typeof window !== 'undefined' && (window as any).grecaptcha) {
      if ((window as any).grecaptcha.ready) {
        ;(window as any).grecaptcha.ready(() => {
          if (
            (window as any).grecaptcha.enterprise &&
            typeof (window as any).grecaptcha.enterprise.reset === 'function'
          ) {
            ;(window as any).grecaptcha.enterprise.reset()
          }
        })
      } else if (
        (window as any).grecaptcha.enterprise &&
        typeof (window as any).grecaptcha.enterprise.reset === 'function'
      ) {
        ;(window as any).grecaptcha.enterprise.reset()
      }
    }
    setCaptchaVerified(false)
    setCaptchaToken(undefined)
  }

  return (
    <div className='space-y-4 rounded-lg'>
      <Tabs index={activeTabIndex} onChange={handleTabChange}>
        <TabList className=' [&>*]:!flex-1' disableScroll block>
          <Tab>{t('form.labels.email')}</Tab>
          <Tab>{t('form.labels.phone')}</Tab>
        </TabList>

        <TabPanels className='pt-4'>
          <TabPanel className='space-y-4'>
            <EmailInput
              emailInput={emailInput}
              setEmailInput={setEmailInput}
              disabled={false}
              required={true}
              showLabel={false}
              placeholder={t('form.placeholders.email')}
            />
          </TabPanel>

          <TabPanel className='space-y-4'>
            <PhoneInput
              phoneInput={phoneInput}
              setPhoneInput={setPhoneInput}
              disabled={false}
              required={true}
              showLabel={false}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>

      <ReCaptcha
        setCaptchaVerified={setCaptchaVerified}
        setCaptchaToken={setCaptchaToken}
      />

      <Button
        disabled={!isValid() || !captchaVerified || isLookupLoading}
        onClick={handleSubmit}
        className='mt-4 w-full'
      >
        Look up
      </Button>

      <Button
        onClick={() => {
          resetSignup()
          navigate(`/${shortUrl}/rewardsSignup`)
        }}
        variant='link'
        className='mt-4 w-full text-link flex justify-center'
      >
        Join as a new member
      </Button>
    </div>
  )
}
